import axios from 'axios'

class AccountFactory {
  async get (data: any) {
    try {
      const url = '/acc/accounts'
      const response = await axios.get(url, {
        params: {
          keyword: data.keyword,
          offset: data.offset,
          limit: data.limit,
          order_by: data.order_by,
          order_at: data.order_at
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async search (keyword: string) {
    try {
      const url = '/acc/accounts/search'
      const params = { keyword: keyword }
      const response = await axios.get(url, { params: params })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async getByParent (keyword: string) {
    try {
      const url = '/acc/accounts'
      const params = { keyword: keyword }
      const response = await axios.get(url, { params: params })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async create (data: any) {
    try {
      const url = '/acc/accounts'
      const response = await axios.post(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async update (id: any, data: any) {
    try {
      const url = `/acc/accounts/${id}`
      const response = await axios.put(url, data)
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async exportAccount () {
    try {
      const url = '/acc/account/export'
      const response = await axios.get(url, {
        responseType: 'arraybuffer'
      })
      const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Master_Akun.xlsx'
      link.click()
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async importAccount (data: any) {
    try {
      const url = '/acc/account/import'
      const response = await axios.post(url, data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      return response.data
    } catch (error) {
      console.error(error)
      return false
    }
  }

  async delete (id: any) {
    try {
      const url = `acc/accounts/${id}/delete`
      const response = await axios.post(url)
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }

  async bulkDelete (ids: Array<number>) {
    try {
      const url = 'acc/accounts/bulk_delete'
      const response = await axios.post(url, { ids: ids })
      return response.data
    } catch (error) {
      console.error(error)
      return error
    }
  }
}

export const accountFactory = new AccountFactory()
